import { render } from "./MobileAppDemoPhone.vue?vue&type=template&id=e163fce6&scoped=true"
import script from "./MobileAppDemoPhone.vue?vue&type=script&lang=js"
export * from "./MobileAppDemoPhone.vue?vue&type=script&lang=js"

import "./MobileAppDemoPhone.vue?vue&type=style&index=0&id=e163fce6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e163fce6"]])

export default __exports__